const state = {
  list: undefined
}

const mutations = {
  set(state, list) {
    state.list = list
  }
}

const actions = {
  getList(context) {
    return new Promise((resolve, reject) => {
      if (context.state.list == undefined) {
        V.$api.role.getAuths().then(r => {
          context.commit("set", r.Data);
          resolve(r.Data)
        }).catch(() => {});
      } else {
        resolve(context.state.list)
      }
    });
  }
}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}